var map = {
	"./Airplane_French_Avion.png": 66862,
	"./Airplane_German_Flugzeug.png": 44956,
	"./Airplane_Italian_Aereo.png": 73201,
	"./Airplane_Polish_Samolot.png": 8937,
	"./Airplane_Portuguese_Avião.png": 40632,
	"./Airplane_Spanish_Avión.png": 10808,
	"./Almond_French_Amande.png": 63898,
	"./Almond_German_Mandel.png": 50673,
	"./Almond_Italian_Mandorla.png": 45102,
	"./Almond_Polish_Migdał.png": 31479,
	"./Almond_Portuguese_Amêndoa.png": 99175,
	"./Almond_Spanish_Almendra.png": 13120,
	"./Ankle_French_Cheville.png": 65954,
	"./Ankle_German_Knöchel.png": 7053,
	"./Ankle_Italian_Caviglia.png": 93192,
	"./Ankle_Polish_Kostka.png": 33214,
	"./Ankle_Portuguese_Tornozelo.png": 1975,
	"./Ankle_Spanish_Tobillo.png": 55837,
	"./Apple_French_Pomme.png": 99527,
	"./Apple_German_Apfel.png": 92139,
	"./Apple_Italian_Mela.png": 3632,
	"./Apple_Polish_Jabłko.png": 29217,
	"./Apple_Portuguese_Maçã.png": 28904,
	"./Apple_Spanish_Manzana.png": 28619,
	"./Apron_French_Tablier.png": 37932,
	"./Apron_German_Schürze.png": 67528,
	"./Apron_Italian_Grembiule.png": 80845,
	"./Apron_Polish_Fartuch.png": 58301,
	"./Apron_Portuguese_Avental.png": 59113,
	"./Apron_Spanish_Delantal.png": 22706,
	"./Arm_French_Bras.png": 76623,
	"./Arm_German_Arm.png": 37783,
	"./Arm_Italian_Braccio.png": 67086,
	"./Arm_Polish_Ramię.png": 16242,
	"./Arm_Portuguese_Braço.png": 80951,
	"./Arm_Spanish_Brazo.png": 9125,
	"./Art_French_Art.png": 21443,
	"./Art_German_Kunst.png": 59045,
	"./Art_Italian_Arte.png": 73438,
	"./Art_Polish_Sztuka.png": 7689,
	"./Art_Portuguese_Arte.png": 58611,
	"./Art_Spanish_Arte.png": 83198,
	"./Baby_French_Bébé.png": 22097,
	"./Baby_German_Baby.png": 90783,
	"./Baby_Italian_Bambino.png": 78789,
	"./Baby_Polish_Dziecko.png": 75307,
	"./Baby_Portuguese_Bebê.png": 39335,
	"./Baby_Spanish_Bebé.png": 46611,
	"./Bag_French_Sac.png": 63060,
	"./Bag_German_Tasche.png": 97207,
	"./Bag_Italian_Borsa.png": 68416,
	"./Bag_Polish_Torba.png": 69644,
	"./Bag_Portuguese_Bolsa.png": 44127,
	"./Bag_Spanish_Bolsa.png": 10290,
	"./Ball_French_Balle.png": 92288,
	"./Ball_German_Ball.png": 79539,
	"./Ball_Italian_Palla.png": 83378,
	"./Ball_Polish_Piłka.png": 22406,
	"./Ball_Portuguese_Bola.png": 57231,
	"./Ball_Spanish_Pelota.png": 54337,
	"./Balloon_French_Ballon.png": 80244,
	"./Balloon_German_Ballon.png": 91618,
	"./Balloon_Italian_Palloncino.png": 19747,
	"./Balloon_Polish_Balon.png": 58815,
	"./Balloon_Portuguese_Balão.png": 77646,
	"./Balloon_Spanish_Globo.png": 40295,
	"./Bathroom_French_Salle de bain.png": 83203,
	"./Bathroom_German_Badezimmer.png": 33515,
	"./Bathroom_Italian_Bagno.png": 83898,
	"./Bathroom_Polish_Łazienka.png": 20426,
	"./Bathroom_Portuguese_Banheiro.png": 32192,
	"./Bathroom_Spanish_Baño.png": 55458,
	"./Bear_French_Ours.png": 41730,
	"./Bear_German_Bär.png": 53841,
	"./Bear_Italian_Orso.png": 33760,
	"./Bear_Polish_Niedźwiedź.png": 85299,
	"./Bear_Portuguese_Urso.png": 66985,
	"./Bear_Spanish_Oso.png": 73216,
	"./Bed_French_Lit.png": 35833,
	"./Bed_German_Bett.png": 92961,
	"./Bed_Italian_Letto.png": 55614,
	"./Bed_Polish_Łóżko.png": 18215,
	"./Bed_Portuguese_Cama.png": 12979,
	"./Bed_Spanish_Cama.png": 68518,
	"./Bee_French_Abeille.png": 51417,
	"./Bee_German_Biene.png": 66196,
	"./Bee_Italian_Ape.png": 91871,
	"./Bee_Polish_Pszczoła.png": 71712,
	"./Bee_Portuguese_Abelha.png": 89683,
	"./Bee_Spanish_Abeja.png": 41050,
	"./Belt_French_Ceinture.png": 15909,
	"./Belt_German_Gürtel.png": 736,
	"./Belt_Italian_Cintura.png": 87348,
	"./Belt_Polish_Pasek.png": 53871,
	"./Belt_Portuguese_Cinto.png": 61074,
	"./Belt_Spanish_Cinturón.png": 73994,
	"./Bench_French_Banc.png": 3925,
	"./Bench_German_Bank.png": 95299,
	"./Bench_Italian_Panca.png": 4004,
	"./Bench_Polish_Ławka.png": 95857,
	"./Bench_Portuguese_Banco.png": 89121,
	"./Bench_Spanish_Banco.png": 10992,
	"./Bicycle_French_Vélo.png": 44706,
	"./Bicycle_German_Fahrrad.png": 72104,
	"./Bicycle_Italian_Bicicletta.png": 76398,
	"./Bicycle_Polish_Rower.png": 78802,
	"./Bicycle_Portuguese_Bicicleta.png": 77521,
	"./Bicycle_Spanish_Bicicleta.png": 23322,
	"./Bird_French_Oiseau.png": 92974,
	"./Bird_German_Vogel.png": 3695,
	"./Bird_Italian_Uccello.png": 99233,
	"./Bird_Polish_Ptak.png": 39693,
	"./Bird_Portuguese_Pássaro.png": 78236,
	"./Bird_Spanish_Pájaro.png": 3611,
	"./Boat_French_Bateau.png": 67379,
	"./Boat_German_Boot.png": 2213,
	"./Boat_Italian_Barca.png": 26938,
	"./Boat_Polish_Łódka.png": 99400,
	"./Boat_Portuguese_Barco.png": 41317,
	"./Boat_Spanish_Barco.png": 3556,
	"./Bone_French_Os.png": 27705,
	"./Bone_German_Knochen.png": 3251,
	"./Bone_Italian_Osso.png": 84897,
	"./Bone_Polish_Kość.png": 49186,
	"./Bone_Portuguese_Osso.png": 36186,
	"./Bone_Spanish_Hueso.png": 57249,
	"./Book_French_Livre.png": 27666,
	"./Book_German_Buch.png": 65558,
	"./Book_Italian_Libro.png": 11884,
	"./Book_Polish_Książka.png": 60219,
	"./Book_Portuguese_Livro.png": 36791,
	"./Book_Spanish_Libro.png": 98988,
	"./Bottle_French_Bouteille.png": 11164,
	"./Bottle_German_Flasche.png": 28431,
	"./Bottle_Italian_Bottiglia.png": 11218,
	"./Bottle_Polish_Butelka.png": 60636,
	"./Bottle_Portuguese_Garrafa.png": 21568,
	"./Bottle_Spanish_Botella.png": 68894,
	"./Bowl_French_Bol.png": 4094,
	"./Bowl_German_Schüssel.png": 19044,
	"./Bowl_Italian_Ciotola.png": 99222,
	"./Bowl_Polish_Miska.png": 85687,
	"./Bowl_Portuguese_Tigela.png": 99956,
	"./Bowl_Spanish_Bol.png": 40768,
	"./Box_French_Boîte.png": 46260,
	"./Box_German_Schachtel.png": 99431,
	"./Box_Italian_Scatola.png": 56913,
	"./Box_Polish_Pudełko.png": 86479,
	"./Box_Portuguese_Caixa.png": 20415,
	"./Box_Spanish_Caja.png": 99821,
	"./Bracelet_French_Bracelet.png": 16189,
	"./Bracelet_German_Armband.png": 73920,
	"./Bracelet_Italian_Braccialetto.png": 7568,
	"./Bracelet_Polish_Bransoletka.png": 32912,
	"./Bracelet_Portuguese_Pulseira.png": 42983,
	"./Bracelet_Spanish_Pulsera.png": 10307,
	"./Brain_French_Cerveau.png": 9170,
	"./Brain_German_Gehirn.png": 79990,
	"./Brain_Italian_Cervello.png": 12391,
	"./Brain_Polish_Mózg.png": 75754,
	"./Brain_Portuguese_Cérebro.png": 43076,
	"./Brain_Spanish_Cerebro.png": 82961,
	"./Bread_French_Pain.png": 54823,
	"./Bread_German_Brot.png": 22936,
	"./Bread_Italian_Pane.png": 45375,
	"./Bread_Polish_Chleb.png": 53046,
	"./Bread_Portuguese_Pão.png": 87862,
	"./Bread_Spanish_Pan.png": 53040,
	"./Broom_French_Balai.png": 13119,
	"./Broom_German_Besen.png": 62317,
	"./Broom_Italian_Scopa.png": 46572,
	"./Broom_Polish_Miotła.png": 1391,
	"./Broom_Portuguese_Vassoura.png": 60869,
	"./Broom_Spanish_Escoba.png": 55439,
	"./Bucket_French_Seau.png": 90525,
	"./Bucket_German_Eimer.png": 93047,
	"./Bucket_Italian_Secchio.png": 335,
	"./Bucket_Polish_Wiaderko.png": 43698,
	"./Bucket_Portuguese_Balde.png": 50940,
	"./Bucket_Spanish_Balde.png": 22709,
	"./Cake_French_Gâteau.png": 38033,
	"./Cake_German_Kuchen.png": 95163,
	"./Cake_Italian_Torta.png": 81453,
	"./Cake_Polish_Ciasto.png": 20251,
	"./Cake_Portuguese_Bolo.png": 10538,
	"./Cake_Spanish_Pastel.png": 88948,
	"./Candy_French_Bonbon.png": 84656,
	"./Candy_German_Bonbon.png": 61574,
	"./Candy_Italian_Caramella.png": 86602,
	"./Candy_Polish_Cukierek.png": 78674,
	"./Candy_Portuguese_Bala.png": 74597,
	"./Candy_Spanish_Dulce.png": 7527,
	"./Car_French_Voiture.png": 60815,
	"./Car_German_Auto.png": 65992,
	"./Car_Italian_Auto.png": 25428,
	"./Car_Polish_Samochód.png": 65918,
	"./Car_Portuguese_Carro.png": 67715,
	"./Car_Spanish_Coche.png": 62393,
	"./Carrot_French_Carotte.png": 5652,
	"./Carrot_German_Karotte.png": 27118,
	"./Carrot_Italian_Carota.png": 15112,
	"./Carrot_Polish_Marchewka.png": 64744,
	"./Carrot_Portuguese_Cenoura.png": 84240,
	"./Carrot_Spanish_Zanahoria.png": 68591,
	"./Castle_French_Château.png": 4971,
	"./Castle_German_Schloss.png": 29532,
	"./Castle_Italian_Castello.png": 18778,
	"./Castle_Polish_Zamek.png": 69970,
	"./Castle_Portuguese_Castelo.png": 14147,
	"./Castle_Spanish_Castillo.png": 18886,
	"./Cat_French_Chat.png": 67287,
	"./Cat_German_Katze.png": 47540,
	"./Cat_Italian_Gatto.png": 75384,
	"./Cat_Polish_Kot.png": 98112,
	"./Cat_Portuguese_Gato.png": 31703,
	"./Cat_Spanish_Gato.png": 7756,
	"./Chair_French_Chaise.png": 60985,
	"./Chair_German_Stuhl.png": 58012,
	"./Chair_Italian_Sedia.png": 71914,
	"./Chair_Polish_Krzesło.png": 46933,
	"./Chair_Portuguese_Cadeira.png": 1118,
	"./Chair_Spanish_Silla.png": 62817,
	"./Cheese_French_Fromage.png": 84161,
	"./Cheese_German_Käse.png": 86537,
	"./Cheese_Italian_Formaggio.png": 47265,
	"./Cheese_Polish_Ser.png": 9393,
	"./Cheese_Portuguese_Queijo.png": 57382,
	"./Cheese_Spanish_Queso.png": 1649,
	"./Cherry_French_Cerise.png": 32397,
	"./Cherry_German_Kirsche.png": 28751,
	"./Cherry_Italian_Ciliegia.png": 52317,
	"./Cherry_Polish_Wiśnia.png": 36806,
	"./Cherry_Portuguese_Cereja.png": 30375,
	"./Cherry_Spanish_Cereza.png": 74870,
	"./Chicken_French_Poulet.png": 82363,
	"./Chicken_German_Hähnchen.png": 17612,
	"./Chicken_Italian_Pollo.png": 89716,
	"./Chicken_Polish_Kurczak.png": 71660,
	"./Chicken_Portuguese_Frango.png": 7538,
	"./Chicken_Spanish_Pollo.png": 71516,
	"./Chocolate_French_Chocolat.png": 77810,
	"./Chocolate_German_Schokolade.png": 58858,
	"./Chocolate_Italian_Cioccolato.png": 32543,
	"./Chocolate_Polish_Czekolada.png": 1490,
	"./Chocolate_Portuguese_Chocolate.png": 26818,
	"./Chocolate_Spanish_Chocolate.png": 49023,
	"./Clock_French_Horloge.png": 40459,
	"./Clock_German_Uhr.png": 68890,
	"./Clock_Italian_Orologio.png": 61613,
	"./Clock_Polish_Zegar.png": 27519,
	"./Clock_Portuguese_Relógio.png": 61983,
	"./Clock_Spanish_Reloj.png": 22051,
	"./Coffee_French_Café.png": 23866,
	"./Coffee_German_Kaffee.png": 74717,
	"./Coffee_Italian_Caffè.png": 23727,
	"./Coffee_Polish_Kawa.png": 67928,
	"./Coffee_Portuguese_Café.png": 87295,
	"./Coffee_Spanish_Café.png": 480,
	"./Coin_French_Pièce de monnaie.png": 41689,
	"./Coin_German_Münze.png": 93854,
	"./Coin_Italian_Moneta.png": 20520,
	"./Coin_Polish_Moneta.png": 41221,
	"./Coin_Portuguese_Moeda.png": 56331,
	"./Coin_Spanish_Moneda.png": 66536,
	"./Cold_French_Froid.png": 5139,
	"./Cold_German_Kalt.png": 18425,
	"./Cold_Italian_Freddo.png": 17773,
	"./Cold_Polish_Zimny.png": 4615,
	"./Cold_Portuguese_Frio.png": 73062,
	"./Cold_Spanish_Frío.png": 14997,
	"./Cookie_French_Biscuit.png": 83930,
	"./Cookie_German_Plätzchen.png": 24039,
	"./Cookie_Italian_Biscotto.png": 55310,
	"./Cookie_Polish_Ciastko.png": 68798,
	"./Cookie_Portuguese_Biscoito.png": 15100,
	"./Cookie_Spanish_Galleta.png": 5121,
	"./Couch_French_Canapé.png": 73621,
	"./Couch_German_Couch.png": 65991,
	"./Couch_Italian_Divano.png": 46738,
	"./Couch_Polish_Kanapa.png": 36608,
	"./Couch_Portuguese_Sofá.png": 49663,
	"./Couch_Spanish_Sofá.png": 60276,
	"./Cow_French_Vache.png": 96389,
	"./Cow_German_Kuh.png": 67560,
	"./Cow_Italian_Mucca.png": 74335,
	"./Cow_Polish_Krowa.png": 52663,
	"./Cow_Portuguese_Vaca.png": 62598,
	"./Cow_Spanish_Vaca.png": 11699,
	"./Doctor_French_Médecin.png": 38241,
	"./Doctor_German_Arzt.png": 19821,
	"./Doctor_Italian_Medico.png": 81545,
	"./Doctor_Polish_Lekarz.png": 72688,
	"./Doctor_Portuguese_Doutor.png": 41142,
	"./Doctor_Spanish_Doctor.png": 94177,
	"./Dog_French_Chien.png": 1620,
	"./Dog_German_Hund.png": 59498,
	"./Dog_Italian_Cane.png": 49810,
	"./Dog_Polish_Pies.png": 10151,
	"./Dog_Portuguese_Cachorro.png": 93761,
	"./Dog_Spanish_Perro.png": 81921,
	"./Doll_French_Poupée.png": 14776,
	"./Doll_German_Puppe.png": 7128,
	"./Doll_Italian_Bambola.png": 36692,
	"./Doll_Polish_Lalka.png": 76732,
	"./Doll_Portuguese_Boneca.png": 56825,
	"./Doll_Spanish_Muñeca.png": 39982,
	"./Door_French_Porte.png": 40055,
	"./Door_German_Tür.png": 91069,
	"./Door_Italian_Porta.png": 66669,
	"./Door_Polish_Drzwi.png": 98634,
	"./Door_Portuguese_Porta.png": 1768,
	"./Door_Spanish_Puerta.png": 10078,
	"./Dress_French_Robe.png": 40278,
	"./Dress_German_Kleid.png": 40105,
	"./Dress_Italian_Vestito.png": 55446,
	"./Dress_Polish_Sukienka.png": 98152,
	"./Dress_Portuguese_Vestido.png": 84801,
	"./Dress_Spanish_Vestido.png": 53006,
	"./Duck_French_Canard.png": 4179,
	"./Duck_German_Ente.png": 17020,
	"./Duck_Italian_Anatra.png": 70955,
	"./Duck_Polish_Kaczka.png": 35588,
	"./Duck_Portuguese_Pato.png": 30117,
	"./Duck_Spanish_Pato.png": 87492,
	"./Earring_French_Boucle d'oreille.png": 58652,
	"./Earring_German_Ohrring.png": 95698,
	"./Earring_Italian_Orecchino.png": 94851,
	"./Earring_Polish_Kolczyk.png": 41557,
	"./Earring_Portuguese_Brinco.png": 43005,
	"./Earring_Spanish_Arete.png": 42522,
	"./Egg_French_Œuf.png": 91303,
	"./Egg_German_Ei.png": 89718,
	"./Egg_Italian_Uovo.png": 40815,
	"./Egg_Polish_Jajko.png": 23514,
	"./Egg_Portuguese_Ovo.png": 64589,
	"./Egg_Spanish_Huevo.png": 77147,
	"./Eight_French_Huit.png": 10606,
	"./Eight_German_Acht.png": 88170,
	"./Eight_Italian_Otto.png": 87958,
	"./Eight_Polish_Osiem.png": 45592,
	"./Eight_Portuguese_Oito.png": 47066,
	"./Eight_Spanish_Ocho.png": 4981,
	"./Eye_French_Œil.png": 90385,
	"./Eye_German_Auge.png": 75390,
	"./Eye_Italian_Occhio.png": 79201,
	"./Eye_Polish_Oko.png": 36546,
	"./Eye_Portuguese_Olho.png": 92821,
	"./Eye_Spanish_Ojo.png": 58886,
	"./Face_French_Affronter.png": 21611,
	"./Face_German_Gesicht.png": 79921,
	"./Face_Italian_Viso.png": 2883,
	"./Face_Polish_Twarz.png": 89143,
	"./Face_Portuguese_Face.png": 23108,
	"./Face_Spanish_Rostro.png": 98835,
	"./Farm_French_Ferme.png": 98076,
	"./Farm_German_Bauernhof.png": 83703,
	"./Farm_Italian_Azienda agricola.png": 35953,
	"./Farm_Polish_Farma.png": 91835,
	"./Farm_Portuguese_Fazenda.png": 90945,
	"./Farm_Spanish_Granja.png": 18646,
	"./Finger_French_Doigt.png": 84693,
	"./Finger_German_Finger.png": 43343,
	"./Finger_Italian_Dito.png": 64240,
	"./Finger_Polish_Palec.png": 33320,
	"./Finger_Portuguese_Dedo.png": 83853,
	"./Finger_Spanish_Dedo.png": 86732,
	"./Fire_French_Feu.png": 72197,
	"./Fire_German_Feuer.png": 38014,
	"./Fire_Italian_Fuoco.png": 65683,
	"./Fire_Polish_Ogień.png": 87118,
	"./Fire_Portuguese_Fogo.png": 98331,
	"./Fire_Spanish_Fuego.png": 32681,
	"./Fish_French_Poisson.png": 24530,
	"./Fish_German_Fisch.png": 99558,
	"./Fish_Italian_Pescare.png": 51458,
	"./Fish_Polish_Ryba.png": 96102,
	"./Fish_Portuguese_Peixe.png": 66707,
	"./Fish_Spanish_Pez.png": 99508,
	"./Five_French_Cinq.png": 25238,
	"./Five_German_Fünf.png": 94869,
	"./Five_Italian_Cinque.png": 64390,
	"./Five_Polish_Pięć.png": 9017,
	"./Five_Portuguese_Cinco.png": 60522,
	"./Five_Spanish_Cinco.png": 3763,
	"./Flour_French_Farine.png": 3322,
	"./Flour_German_Mehl.png": 19013,
	"./Flour_Italian_Farina.png": 73056,
	"./Flour_Polish_Mąka.png": 49286,
	"./Flour_Portuguese_Farinha.png": 78929,
	"./Flour_Spanish_Harina.png": 61026,
	"./Flower_French_Fleur.png": 14488,
	"./Flower_German_Blume.png": 88629,
	"./Flower_Italian_Fiore.png": 85995,
	"./Flower_Polish_Kwiat.png": 99281,
	"./Flower_Portuguese_Flor.png": 59732,
	"./Flower_Spanish_Flor.png": 99377,
	"./Fork_French_Fourchette.png": 10922,
	"./Fork_German_Gabel.png": 94106,
	"./Fork_Italian_Forchetta.png": 30201,
	"./Fork_Polish_Widelec.png": 22557,
	"./Fork_Portuguese_Garfo.png": 21181,
	"./Fork_Spanish_Tenedor.png": 53066,
	"./Four_French_Quatre.png": 14191,
	"./Four_German_Vier.png": 64845,
	"./Four_Italian_Quattro.png": 95149,
	"./Four_Polish_Cztery.png": 12401,
	"./Four_Portuguese_Quatro.png": 59008,
	"./Four_Spanish_Cuatro.png": 79925,
	"./Fruit_French_Fruit.png": 49829,
	"./Fruit_German_Obst.png": 55163,
	"./Fruit_Italian_Frutta.png": 42419,
	"./Fruit_Polish_Owoc.png": 11842,
	"./Fruit_Portuguese_Fruta.png": 34532,
	"./Fruit_Spanish_Fruta.png": 5285,
	"./Garlic_French_Ail.png": 4837,
	"./Garlic_German_Knoblauch.png": 31614,
	"./Garlic_Italian_Aglio.png": 62661,
	"./Garlic_Polish_Czosnek.png": 72977,
	"./Garlic_Portuguese_Alho.png": 56410,
	"./Garlic_Spanish_Ajo.png": 68013,
	"./Glass_French_Verre.png": 60453,
	"./Glass_German_Glas.png": 98294,
	"./Glass_Italian_Bicchiere.png": 66937,
	"./Glass_Polish_Szklanka.png": 49015,
	"./Glass_Portuguese_Copo.png": 44737,
	"./Glass_Spanish_Vaso.png": 51162,
	"./Glove_French_Gant.png": 55304,
	"./Glove_German_Handschuh.png": 49942,
	"./Glove_Italian_Guanto.png": 59300,
	"./Glove_Polish_Rękawica.png": 16988,
	"./Glove_Portuguese_Luva.png": 10185,
	"./Glove_Spanish_Guante.png": 18766,
	"./Grape_French_Raisin.png": 78294,
	"./Grape_German_Traube.png": 41917,
	"./Grape_Italian_Uva.png": 1916,
	"./Grape_Polish_Winogrono.png": 42789,
	"./Grape_Portuguese_Uva.png": 70519,
	"./Grape_Spanish_Uva.png": 48244,
	"./Green_French_Vert.png": 14177,
	"./Green_German_Grün.png": 4879,
	"./Green_Italian_Verde.png": 27416,
	"./Green_Polish_Zielony.png": 66313,
	"./Green_Portuguese_Verde.png": 94583,
	"./Green_Spanish_Verde.png": 94288,
	"./Hand_French_Main.png": 47097,
	"./Hand_German_Hand.png": 86027,
	"./Hand_Italian_Mano.png": 10669,
	"./Hand_Polish_Ręka.png": 55040,
	"./Hand_Portuguese_Mão.png": 39804,
	"./Hand_Spanish_Mano.png": 12317,
	"./Hat_French_Chapeau.png": 78345,
	"./Hat_German_Hut.png": 20837,
	"./Hat_Italian_Cappello.png": 38814,
	"./Hat_Polish_Kapelusz.png": 65088,
	"./Hat_Portuguese_Chapéu.png": 54175,
	"./Hat_Spanish_Sombrero.png": 44551,
	"./Head_French_Tête.png": 50772,
	"./Head_German_Kopf.png": 16665,
	"./Head_Italian_Testa.png": 50244,
	"./Head_Polish_Głowa.png": 66066,
	"./Head_Portuguese_Cabeça.png": 50725,
	"./Head_Spanish_Cabeza.png": 53821,
	"./Health_French_Santé.png": 86540,
	"./Health_German_Gesundheit.png": 28269,
	"./Health_Italian_Salute.png": 56833,
	"./Health_Polish_Zdrowie.png": 54972,
	"./Health_Portuguese_Saúde.png": 95279,
	"./Health_Spanish_Salud.png": 4510,
	"./Heart_French_Cœur.png": 76358,
	"./Heart_German_Herz.png": 24134,
	"./Heart_Italian_Cuore.png": 19367,
	"./Heart_Polish_Serce.png": 45303,
	"./Heart_Portuguese_Coração.png": 44080,
	"./Heart_Spanish_Corazón.png": 44021,
	"./Heavy_French_Lourd.png": 41932,
	"./Heavy_German_Schwer.png": 28990,
	"./Heavy_Italian_Pesante.png": 7470,
	"./Heavy_Polish_Ciężki.png": 47334,
	"./Heavy_Portuguese_Pesado.png": 18647,
	"./Heavy_Spanish_Pesado.png": 94846,
	"./Help_French_Aide.png": 38731,
	"./Help_German_Helfen.png": 30112,
	"./Help_Italian_Aiuto.png": 87670,
	"./Help_Polish_Pomoc.png": 69535,
	"./Help_Portuguese_Ajuda.png": 84958,
	"./Help_Spanish_Ayuda.png": 95712,
	"./History_French_Histoire.png": 71778,
	"./History_German_Geschichte.png": 13392,
	"./History_Italian_Storia.png": 50683,
	"./History_Polish_Historia.png": 83593,
	"./History_Portuguese_História.png": 27069,
	"./History_Spanish_Historia.png": 88606,
	"./Hook_French_Crochet.png": 84702,
	"./Hook_German_Haken.png": 96978,
	"./Hook_Italian_Gancio.png": 49745,
	"./Hook_Polish_Hak.png": 30377,
	"./Hook_Portuguese_Gancho.png": 42467,
	"./Hook_Spanish_Gancho.png": 75198,
	"./Horse_French_Cheval.png": 44417,
	"./Horse_German_Pferd.png": 36763,
	"./Horse_Italian_Cavallo.png": 78262,
	"./Horse_Polish_Koń.png": 44649,
	"./Horse_Portuguese_Cavalo.png": 69963,
	"./Horse_Spanish_Caballo.png": 96394,
	"./Hose_French_Tuyau.png": 96552,
	"./Hose_German_Schlauch.png": 47381,
	"./Hose_Italian_Tubo flessibile.png": 80736,
	"./Hose_Polish_Wąż gumowy.png": 85199,
	"./Hose_Portuguese_Mangueira.png": 59734,
	"./Hose_Spanish_Manguera.png": 64584,
	"./Hospital_French_Hôpital.png": 38979,
	"./Hospital_German_Krankenhaus.png": 26656,
	"./Hospital_Italian_Ospedale.png": 36310,
	"./Hospital_Polish_Szpital.png": 56753,
	"./Hospital_Portuguese_Hospital.png": 14204,
	"./Hospital_Spanish_Hospital.png": 16075,
	"./Hot_French_Chaud.png": 65275,
	"./Hot_German_Heiß.png": 51043,
	"./Hot_Italian_Caldo.png": 36857,
	"./Hot_Polish_Gorący.png": 92676,
	"./Hot_Portuguese_Quente.png": 48435,
	"./Hot_Spanish_Caliente.png": 30053,
	"./House_French_Maison.png": 74140,
	"./House_German_Haus.png": 75090,
	"./House_Italian_Casa.png": 58083,
	"./House_Polish_Dom.png": 36458,
	"./House_Portuguese_Casa.png": 29220,
	"./House_Spanish_Casa.png": 41859,
	"./Husband_French_Mari.png": 1237,
	"./Husband_German_Ehemann.png": 15918,
	"./Husband_Italian_Marito.png": 84662,
	"./Husband_Polish_Mąż.png": 29239,
	"./Husband_Portuguese_Marido.png": 69615,
	"./Husband_Spanish_Marido.png": 36862,
	"./Jug_French_Cruche.png": 29225,
	"./Jug_German_Krug.png": 67646,
	"./Jug_Italian_Brocca.png": 71767,
	"./Jug_Polish_Dzbanek.png": 97777,
	"./Jug_Portuguese_Jarro.png": 49030,
	"./Jug_Spanish_Jarra.png": 72653,
	"./Key_French_Clé.png": 86584,
	"./Key_German_Schlüssel.png": 77327,
	"./Key_Italian_Chiave.png": 22120,
	"./Key_Polish_Klucz.png": 22436,
	"./Key_Portuguese_Chave.png": 59604,
	"./Key_Spanish_Llave.png": 3512,
	"./Kite_French_Cerf-volant.png": 95445,
	"./Kite_German_Drachen.png": 85979,
	"./Kite_Italian_Aquilone.png": 99836,
	"./Kite_Polish_Latawiec.png": 81093,
	"./Kite_Portuguese_Pipa.png": 65105,
	"./Kite_Spanish_Cometa.png": 33721,
	"./Knife_French_Couteau.png": 78404,
	"./Knife_German_Messer.png": 87017,
	"./Knife_Italian_Coltello.png": 69232,
	"./Knife_Polish_Nóż.png": 3047,
	"./Knife_Portuguese_Faca.png": 39104,
	"./Knife_Spanish_Cuchillo.png": 5143,
	"./Large_French_Grand.png": 50364,
	"./Large_German_Groß.png": 96823,
	"./Large_Italian_Grande.png": 47299,
	"./Large_Polish_Duży.png": 6525,
	"./Large_Portuguese_Grande.png": 45054,
	"./Large_Spanish_Grande.png": 60043,
	"./Left_French_Gauche.png": 29135,
	"./Left_German_Links.png": 30457,
	"./Left_Italian_Sinistra.png": 73819,
	"./Left_Polish_Lewy.png": 86774,
	"./Left_Portuguese_Esquerda.png": 3153,
	"./Left_Spanish_Izquierda.png": 7368,
	"./Leg_French_Jambe.png": 15270,
	"./Leg_German_Bein.png": 24341,
	"./Leg_Italian_Gamba.png": 25025,
	"./Leg_Polish_Noga.png": 20981,
	"./Leg_Portuguese_Perna.png": 63844,
	"./Leg_Spanish_Pierna.png": 86784,
	"./Lemon_French_Citron.png": 10089,
	"./Lemon_German_Zitrone.png": 94803,
	"./Lemon_Italian_Limone.png": 48766,
	"./Lemon_Polish_Cytryna.png": 48961,
	"./Lemon_Portuguese_Limão.png": 23349,
	"./Lemon_Spanish_Limón.png": 12383,
	"./Lentil_French_Lentille.png": 76972,
	"./Lentil_German_Linse.png": 43214,
	"./Lentil_Italian_Lenticchia.png": 22315,
	"./Lentil_Polish_Soczewica.png": 61312,
	"./Lentil_Portuguese_Lentilha.png": 73069,
	"./Lentil_Spanish_Lenteja.png": 60728,
	"./Lion_French_Lion.png": 88725,
	"./Lion_German_Löwe.png": 19911,
	"./Lion_Italian_Leone.png": 23346,
	"./Lion_Polish_Lew.png": 56132,
	"./Lion_Portuguese_Leão.png": 6597,
	"./Lion_Spanish_León.png": 39491,
	"./Long_French_Long.png": 5653,
	"./Long_German_Lang.png": 9773,
	"./Long_Italian_Lungo.png": 23470,
	"./Long_Polish_Długi.png": 74419,
	"./Long_Portuguese_Longo.png": 51093,
	"./Long_Spanish_Largo.png": 32190,
	"./Luggage_French_Bagage.png": 49730,
	"./Luggage_German_Gepäck.png": 26217,
	"./Luggage_Italian_Bagaglio.png": 84925,
	"./Luggage_Polish_Bagaż.png": 79203,
	"./Luggage_Portuguese_Bagagem.png": 39890,
	"./Luggage_Spanish_Equipaje.png": 30893,
	"./Man_French_Homme.png": 54995,
	"./Man_German_Mann.png": 62193,
	"./Man_Italian_Uomo.png": 52451,
	"./Man_Polish_Człowiek.png": 92542,
	"./Man_Portuguese_Homem.png": 3120,
	"./Man_Spanish_Hombre.png": 57818,
	"./Mattress_French_Matelas.png": 54461,
	"./Mattress_German_Matratze.png": 49900,
	"./Mattress_Italian_Materasso.png": 86305,
	"./Mattress_Polish_Materac.png": 28648,
	"./Mattress_Portuguese_Colchão.png": 76154,
	"./Mattress_Spanish_Colchón.png": 51132,
	"./Milk_French_Lait.png": 44990,
	"./Milk_German_Milch.png": 56383,
	"./Milk_Italian_Latte.png": 58772,
	"./Milk_Polish_Mleko.png": 67631,
	"./Milk_Portuguese_Leite.png": 76682,
	"./Milk_Spanish_Leche.png": 28179,
	"./Mirror_French_Miroir.png": 53122,
	"./Mirror_German_Spiegel.png": 71865,
	"./Mirror_Italian_Specchio.png": 97988,
	"./Mirror_Polish_Lustro.png": 23668,
	"./Mirror_Portuguese_Espelho.png": 37725,
	"./Mirror_Spanish_Espejo.png": 46336,
	"./Money_French_Argent.png": 622,
	"./Money_German_Geld.png": 90563,
	"./Money_Italian_Soldi.png": 98576,
	"./Money_Polish_Pieniądze.png": 40119,
	"./Money_Portuguese_Dinheiro.png": 25652,
	"./Money_Spanish_Dinero.png": 10916,
	"./Monkey_French_Singe.png": 26242,
	"./Monkey_German_Affe.png": 99398,
	"./Monkey_Italian_Scimmia.png": 97523,
	"./Monkey_Polish_Małpa.png": 44346,
	"./Monkey_Portuguese_Macaco.png": 29887,
	"./Monkey_Spanish_Mono.png": 87627,
	"./Month_French_Mois.png": 19399,
	"./Month_German_Monat.png": 89768,
	"./Month_Italian_Mese.png": 52583,
	"./Month_Polish_Miesiąc.png": 40647,
	"./Month_Portuguese_Mês.png": 7780,
	"./Month_Spanish_Mes.png": 38568,
	"./Morning_French_Matin.png": 7890,
	"./Morning_German_Morgen.png": 20907,
	"./Morning_Italian_Mattina.png": 3579,
	"./Morning_Polish_Rano.png": 94878,
	"./Morning_Portuguese_Manhã.png": 89249,
	"./Morning_Spanish_Mañana.png": 38844,
	"./Mouse_French_Souris.png": 65139,
	"./Mouse_German_Maus.png": 96868,
	"./Mouse_Italian_Topo.png": 1908,
	"./Mouse_Polish_Mysz.png": 66156,
	"./Mouse_Portuguese_Rato.png": 87133,
	"./Mouse_Spanish_Ratón.png": 54960,
	"./Mouth_French_Bouche.png": 960,
	"./Mouth_German_Mund.png": 52222,
	"./Mouth_Italian_Bocca.png": 1650,
	"./Mouth_Polish_Usta.png": 81776,
	"./Mouth_Portuguese_Boca.png": 18972,
	"./Mouth_Spanish_Boca.png": 90729,
	"./Mushroom_French_Champignon.png": 43285,
	"./Mushroom_German_Pilz.png": 47314,
	"./Mushroom_Italian_Fungo.png": 84512,
	"./Mushroom_Polish_Grzyb.png": 88786,
	"./Mushroom_Portuguese_Cogumelo.png": 23145,
	"./Mushroom_Spanish_Champiñón.png": 50037,
	"./Name_French_Nom.png": 57992,
	"./Name_German_Name.png": 10739,
	"./Name_Italian_Nome.png": 5543,
	"./Name_Polish_Nazwa.png": 16802,
	"./Name_Portuguese_Nome.png": 76841,
	"./Name_Spanish_Nombre.png": 36911,
	"./Nest_French_Nid.png": 6142,
	"./Nest_German_Nest.png": 92591,
	"./Nest_Italian_Nido.png": 37977,
	"./Nest_Polish_Gniazdo.png": 92078,
	"./Nest_Portuguese_Ninho.png": 91976,
	"./Nest_Spanish_Nido.png": 71417,
	"./Nine_French_Neuf.png": 33483,
	"./Nine_German_Neun.png": 66633,
	"./Nine_Italian_Nove.png": 79497,
	"./Nine_Polish_Dziewięć.png": 40400,
	"./Nine_Portuguese_Nove.png": 44174,
	"./Nine_Spanish_Nueve.png": 97120,
	"./North_French_Nord.png": 35683,
	"./North_German_Norden.png": 89724,
	"./North_Italian_Nord.png": 24963,
	"./North_Polish_Północ.png": 46124,
	"./North_Portuguese_Norte.png": 65029,
	"./North_Spanish_Norte.png": 69966,
	"./Nose_French_Nez.png": 76609,
	"./Nose_German_Nase.png": 67645,
	"./Nose_Italian_Naso.png": 59281,
	"./Nose_Polish_Nos.png": 53505,
	"./Nose_Portuguese_Nariz.png": 76556,
	"./Nose_Spanish_Nariz.png": 50560,
	"./Oat_French_Avoine.png": 96259,
	"./Oat_German_Hafer.png": 72267,
	"./Oat_Italian_Avena.png": 31134,
	"./Oat_Polish_Owies.png": 84725,
	"./Oat_Portuguese_Aveia.png": 55974,
	"./Oat_Spanish_Avena.png": 50782,
	"./Office_French_Bureau.png": 27543,
	"./Office_German_Büro.png": 916,
	"./Office_Italian_Ufficio.png": 33406,
	"./Office_Polish_Biuro.png": 97803,
	"./Office_Portuguese_Escritório.png": 97351,
	"./Office_Spanish_Oficina.png": 56484,
	"./Oil_French_Huile.png": 47214,
	"./Oil_German_Öl.png": 78481,
	"./Oil_Italian_Olio.png": 23022,
	"./Oil_Polish_Olej.png": 15204,
	"./Oil_Portuguese_Óleo.png": 45157,
	"./Oil_Spanish_Aceite.png": 62920,
	"./One_French_Un.png": 30720,
	"./One_German_Eins.png": 24540,
	"./One_Italian_Uno.png": 40983,
	"./One_Polish_Jeden.png": 57390,
	"./One_Portuguese_Um.png": 42310,
	"./One_Spanish_Uno.png": 36247,
	"./Onion_French_Oignon.png": 8790,
	"./Onion_German_Zwiebel.png": 43590,
	"./Onion_Italian_Cipolla.png": 25900,
	"./Onion_Polish_Cebula.png": 73737,
	"./Onion_Portuguese_Cebola.png": 89767,
	"./Onion_Spanish_Cebolla.png": 37894,
	"./Oven_French_Four.png": 76163,
	"./Oven_German_Ofen.png": 55203,
	"./Oven_Italian_Forno.png": 33785,
	"./Oven_Polish_Piekarnik.png": 22762,
	"./Oven_Portuguese_Forno.png": 64544,
	"./Oven_Spanish_Horno.png": 907,
	"./Owl_French_Hibou.png": 11918,
	"./Owl_German_Eule.png": 49590,
	"./Owl_Italian_Gufo.png": 88964,
	"./Owl_Polish_Sowa.png": 21008,
	"./Owl_Portuguese_Coruja.png": 38400,
	"./Owl_Spanish_Búho.png": 9510,
	"./Oxygen_French_Oxygène.png": 45597,
	"./Oxygen_German_Sauerstoff.png": 32399,
	"./Oxygen_Italian_Ossigeno.png": 44716,
	"./Oxygen_Polish_Tlen.png": 35617,
	"./Oxygen_Portuguese_Oxigênio.png": 91777,
	"./Oxygen_Spanish_Oxígeno.png": 36028,
	"./Pants_French_Pantalon.png": 68024,
	"./Pants_German_Hose.png": 68450,
	"./Pants_Italian_Pantaloni.png": 22577,
	"./Pants_Polish_Spodnie.png": 74104,
	"./Pants_Portuguese_Calças.png": 14465,
	"./Pants_Spanish_Pantalones.png": 47762,
	"./Pear_French_Poire.png": 10934,
	"./Pear_German_Birne.png": 26379,
	"./Pear_Italian_Pera.png": 49945,
	"./Pear_Polish_Gruszka.png": 99665,
	"./Pear_Portuguese_Pera.png": 53954,
	"./Pear_Spanish_Pera.png": 85033,
	"./Pen_French_Stylo.png": 92895,
	"./Pen_German_Stift.png": 16844,
	"./Pen_Italian_Penna.png": 27588,
	"./Pen_Polish_Długopis.png": 6370,
	"./Pen_Portuguese_Caneta.png": 36279,
	"./Pen_Spanish_Bolígrafo.png": 4671,
	"./Pencil_French_Crayon.png": 43948,
	"./Pencil_German_Bleistift.png": 91538,
	"./Pencil_Italian_Matita.png": 55544,
	"./Pencil_Polish_Ołówek.png": 57250,
	"./Pencil_Portuguese_Lápis.png": 48052,
	"./Pencil_Spanish_Lápiz.png": 25070,
	"./Pepper_French_Poivre.png": 39000,
	"./Pepper_German_Pfeffer.png": 91001,
	"./Pepper_Italian_Pepe.png": 47411,
	"./Pepper_Polish_Pieprz.png": 14278,
	"./Pepper_Portuguese_Pimenta.png": 80960,
	"./Pepper_Spanish_Pimienta.png": 77964,
	"./Pig_French_Cochon.png": 3029,
	"./Pig_German_Schwein.png": 39368,
	"./Pig_Italian_Maiale.png": 43474,
	"./Pig_Polish_Świnia.png": 41962,
	"./Pig_Portuguese_Porco.png": 66179,
	"./Pig_Spanish_Cerdo.png": 6302,
	"./Pink_French_Rose.png": 68636,
	"./Pink_German_Rosa.png": 49026,
	"./Pink_Italian_Rosa.png": 15018,
	"./Pink_Polish_Różowy.png": 18970,
	"./Pink_Portuguese_Rosa.png": 88845,
	"./Pink_Spanish_Rosa.png": 47338,
	"./Plum_French_Prune.png": 49275,
	"./Plum_German_Pflaume.png": 70351,
	"./Plum_Italian_Prugna.png": 92920,
	"./Plum_Polish_Śliwka.png": 33844,
	"./Plum_Portuguese_Ameixa.png": 29327,
	"./Plum_Spanish_Ciruelo.png": 77698,
	"./Pool_French_Piscine.png": 82648,
	"./Pool_German_Schwimmbad.png": 56392,
	"./Pool_Italian_Piscina.png": 53922,
	"./Pool_Polish_Basen.png": 52407,
	"./Pool_Portuguese_Piscina.png": 88847,
	"./Pool_Spanish_Piscina.png": 82866,
	"./Popcorn_French_Pop-corn.png": 566,
	"./Popcorn_German_Popcorn.png": 97257,
	"./Popcorn_Italian_Popcorn.png": 19715,
	"./Popcorn_Polish_Popcorn.png": 9811,
	"./Popcorn_Portuguese_Pipoca.png": 11545,
	"./Popcorn_Spanish_Palomitas.png": 63000,
	"./Purple_French_Violet.png": 57274,
	"./Purple_German_Lila.png": 72589,
	"./Purple_Italian_Viola.png": 36098,
	"./Purple_Polish_Fioletowy.png": 5356,
	"./Purple_Portuguese_Roxo.png": 64048,
	"./Purple_Spanish_Morado.png": 14649,
	"./Rabbit_French_Lapin.png": 55007,
	"./Rabbit_German_Hase.png": 99098,
	"./Rabbit_Italian_Coniglio.png": 89759,
	"./Rabbit_Polish_Królik.png": 71446,
	"./Rabbit_Portuguese_Coelho.png": 21202,
	"./Rabbit_Spanish_Conejo.png": 98147,
	"./Rag_French_Chiffon.png": 95374,
	"./Rag_German_Lappen.png": 18453,
	"./Rag_Italian_Straccio.png": 61389,
	"./Rag_Polish_Szmata.png": 45642,
	"./Rag_Portuguese_Pano.png": 64938,
	"./Rag_Spanish_Trapo.png": 89461,
	"./Red_French_Rouge.png": 84812,
	"./Red_German_Rot.png": 33703,
	"./Red_Italian_Rosso.png": 33960,
	"./Red_Polish_Czerwony.png": 42934,
	"./Red_Portuguese_Vermelho.png": 38389,
	"./Red_Spanish_Rojo.png": 92776,
	"./Rice_French_Riz.png": 79151,
	"./Rice_German_Reis.png": 53959,
	"./Rice_Italian_Riso.png": 62195,
	"./Rice_Polish_Ryż.png": 79334,
	"./Rice_Portuguese_Arroz.png": 8549,
	"./Rice_Spanish_Arroz.png": 13462,
	"./Salt_French_Sel.png": 73857,
	"./Salt_German_Salz.png": 12313,
	"./Salt_Italian_Sale.png": 33366,
	"./Salt_Polish_Sól.png": 23032,
	"./Salt_Portuguese_Sal.png": 1370,
	"./Salt_Spanish_Sal.png": 97411,
	"./Sandal_French_Sandale.png": 83152,
	"./Sandal_German_Sandale.png": 85294,
	"./Sandal_Italian_Sandalo.png": 99378,
	"./Sandal_Polish_Sandał.png": 19186,
	"./Sandal_Portuguese_Sandália.png": 99874,
	"./Sandal_Spanish_Sandalia.png": 68751,
	"./Scissors_French_Ciseaux.png": 55120,
	"./Scissors_German_Schere.png": 10902,
	"./Scissors_Italian_Forbici.png": 54636,
	"./Scissors_Polish_Nożyce.png": 14925,
	"./Scissors_Portuguese_Tesoura.png": 54970,
	"./Scissors_Spanish_Tijeras.png": 51082,
	"./Scooter_French_Trottinette.png": 30132,
	"./Scooter_German_Roller.png": 59894,
	"./Scooter_Italian_Scooter.png": 67047,
	"./Scooter_Polish_Hulajnoga.png": 11878,
	"./Scooter_Portuguese_Patinete.png": 93295,
	"./Scooter_Spanish_Scooter.png": 76911,
	"./Seven_French_Sept.png": 33218,
	"./Seven_German_Sieben.png": 16892,
	"./Seven_Italian_Sette.png": 84617,
	"./Seven_Polish_Siedem.png": 48510,
	"./Seven_Portuguese_Sete.png": 88854,
	"./Seven_Spanish_Siete.png": 44980,
	"./Shampoo_French_Shampooing.png": 12331,
	"./Shampoo_German_Shampoo.png": 49737,
	"./Shampoo_Italian_Shampoo.png": 96123,
	"./Shampoo_Polish_Szampon.png": 27875,
	"./Shampoo_Portuguese_Xampu.png": 4764,
	"./Shampoo_Spanish_Champú.png": 93587,
	"./Sheep_French_Mouton.png": 69676,
	"./Sheep_German_Schaf.png": 50687,
	"./Sheep_Italian_Pecora.png": 10716,
	"./Sheep_Polish_Owce.png": 86619,
	"./Sheep_Portuguese_Carneiro.png": 73738,
	"./Sheep_Spanish_Oveja.png": 67557,
	"./Shirt_French_Chemise.png": 17829,
	"./Shirt_German_Hemd.png": 47533,
	"./Shirt_Italian_Camicia.png": 6312,
	"./Shirt_Polish_Koszula.png": 2917,
	"./Shirt_Portuguese_Camisa.png": 32050,
	"./Shirt_Spanish_Camisa.png": 16573,
	"./Shoe_French_Chaussure.png": 17387,
	"./Shoe_German_Schuh.png": 25297,
	"./Shoe_Italian_Scarpa.png": 9106,
	"./Shoe_Polish_But.png": 89176,
	"./Shoe_Portuguese_Sapato.png": 32927,
	"./Shoe_Spanish_Zapato.png": 65233,
	"./Short_French_Court.png": 810,
	"./Short_German_Kurz.png": 46057,
	"./Short_Italian_Corto.png": 39938,
	"./Short_Polish_Krótki.png": 52588,
	"./Short_Portuguese_Curto.png": 9621,
	"./Short_Spanish_Corto.png": 7346,
	"./Shovel_French_Pelle.png": 67400,
	"./Shovel_German_Schaufel.png": 62771,
	"./Shovel_Italian_Pala.png": 77019,
	"./Shovel_Polish_Łopata.png": 37933,
	"./Shovel_Portuguese_Pá.png": 9692,
	"./Shovel_Spanish_Pala.png": 69968,
	"./Sister_French_Sœur.png": 2414,
	"./Sister_German_Schwester.png": 29477,
	"./Sister_Italian_Sorella.png": 24949,
	"./Sister_Polish_Siostra.png": 35087,
	"./Sister_Portuguese_Irmã.png": 14557,
	"./Sister_Spanish_Hermana.png": 81227,
	"./Six_French_Six.png": 70049,
	"./Six_German_Sechs.png": 7155,
	"./Six_Italian_Sei.png": 55690,
	"./Six_Polish_Sześć.png": 35724,
	"./Six_Portuguese_Seis.png": 19840,
	"./Six_Spanish_Seis.png": 44763,
	"./Skin_French_Peau.png": 39541,
	"./Skin_German_Haut.png": 8482,
	"./Skin_Italian_Pelle.png": 75710,
	"./Skin_Polish_Skóra.png": 22877,
	"./Skin_Portuguese_Pele.png": 12939,
	"./Skin_Spanish_Piel.png": 50388,
	"./Small_French_Petit.png": 42274,
	"./Small_German_Klein.png": 44935,
	"./Small_Italian_Piccolo.png": 50231,
	"./Small_Polish_Mały.png": 79988,
	"./Small_Portuguese_Pequeno.png": 58292,
	"./Small_Spanish_Pequeño.png": 75886,
	"./Smile_French_Sourire.png": 93098,
	"./Smile_German_Lächeln.png": 14583,
	"./Smile_Italian_Sorriso.png": 49438,
	"./Smile_Polish_Uśmiech.png": 58140,
	"./Smile_Portuguese_Sorriso.png": 29087,
	"./Smile_Spanish_Sonrisa.png": 36332,
	"./Snake_French_Serpent.png": 74352,
	"./Snake_German_Schlange.png": 81660,
	"./Snake_Italian_Serpente.png": 46561,
	"./Snake_Polish_Wąż.png": 13154,
	"./Snake_Portuguese_Cobra.png": 73185,
	"./Snake_Spanish_Serpiente.png": 75032,
	"./Sock_French_Chaussette.png": 76738,
	"./Sock_German_Socke.png": 73746,
	"./Sock_Italian_Calzino.png": 67741,
	"./Sock_Polish_Skarpetka.png": 24684,
	"./Sock_Portuguese_Meia.png": 69660,
	"./Sock_Spanish_Calcetín.png": 8930,
	"./Soup_French_Soupe.png": 7556,
	"./Soup_German_Suppe.png": 15349,
	"./Soup_Italian_Minestra.png": 26227,
	"./Soup_Polish_Zupa.png": 379,
	"./Soup_Portuguese_Sopa.png": 57870,
	"./Soup_Spanish_Sopa.png": 31815,
	"./South_French_Sud.png": 46524,
	"./South_German_Süd.png": 77109,
	"./South_Italian_Sud.png": 71052,
	"./South_Polish_Południe.png": 94963,
	"./South_Portuguese_Sul.png": 12799,
	"./South_Spanish_Sur.png": 52858,
	"./Spinach_French_Épinard.png": 728,
	"./Spinach_German_Spinat.png": 42288,
	"./Spinach_Italian_Spinaci.png": 60886,
	"./Spinach_Polish_Szpinak.png": 76918,
	"./Spinach_Portuguese_Espinafre.png": 99637,
	"./Spinach_Spanish_Espinaca.png": 5585,
	"./Spoon_French_Cuillère.png": 7250,
	"./Spoon_German_Löffel.png": 83773,
	"./Spoon_Italian_Cucchiaio.png": 30972,
	"./Spoon_Polish_Łyżka.png": 49449,
	"./Spoon_Portuguese_Colher.png": 16648,
	"./Spoon_Spanish_Cuchara.png": 82973,
	"./Strawberry_French_Fraise.png": 2844,
	"./Strawberry_German_Erdbeere.png": 33558,
	"./Strawberry_Italian_Fragola.png": 28762,
	"./Strawberry_Polish_Truskawka.png": 5986,
	"./Strawberry_Portuguese_Morango.png": 89938,
	"./Strawberry_Spanish_Fresa.png": 80057,
	"./Student_French_Étudiant.png": 84388,
	"./Study_French_Étude.png": 65553,
	"./Study_German_Studie.png": 91396,
	"./Study_Italian_Studio.png": 27664,
	"./Study_Polish_Badanie.png": 8881,
	"./Study_Portuguese_Estudar.png": 55953,
	"./Study_Spanish_Estudiar.png": 45443,
	"./Table_French_Table.png": 37553,
	"./Table_German_Tisch.png": 3430,
	"./Table_Italian_Tavolo.png": 61852,
	"./Table_Polish_Stół.png": 94602,
	"./Table_Portuguese_Mesa.png": 24774,
	"./Table_Spanish_Mesa.png": 84853,
	"./Taco_French_Tacos.png": 4746,
	"./Taco_German_Taco.png": 47619,
	"./Taco_Italian_Taco.png": 4677,
	"./Taco_Polish_Taco.png": 40232,
	"./Taco_Portuguese_Taco.png": 1156,
	"./Taco_Spanish_Tacos.png": 64874,
	"./Tea_French_Thé.png": 80186,
	"./Tea_German_Tee.png": 77855,
	"./Tea_Italian_Tè.png": 59201,
	"./Tea_Polish_Herbata.png": 41179,
	"./Tea_Portuguese_Chá.png": 83246,
	"./Tea_Spanish_Té.png": 87336,
	"./Teacher_French_Professeur.png": 97295,
	"./Teacher_German_Lehrer.png": 45555,
	"./Teacher_Italian_Insegnante.png": 58119,
	"./Teacher_Polish_Nauczyciel.png": 77689,
	"./Teacher_Portuguese_Professor.png": 74183,
	"./Teacher_Spanish_Maestro.png": 25398,
	"./Ten_French_Dix.png": 71117,
	"./Ten_German_Zehn.png": 58511,
	"./Ten_Italian_Dieci.png": 92908,
	"./Ten_Polish_Dziesięć.png": 8045,
	"./Ten_Portuguese_Dez.png": 47804,
	"./Ten_Spanish_Diez.png": 14112,
	"./Three_French_Trois.png": 9592,
	"./Three_German_Drei.png": 23115,
	"./Three_Italian_Tre.png": 71632,
	"./Three_Polish_Trzy.png": 34589,
	"./Three_Portuguese_Três.png": 32639,
	"./Three_Spanish_Tres.png": 23369,
	"./Toaster_French_Grille-pain.png": 94403,
	"./Toaster_German_Toaster.png": 91887,
	"./Toaster_Italian_Tostapane.png": 22866,
	"./Toaster_Polish_Opiekacz.png": 72588,
	"./Toaster_Portuguese_Torradeira.png": 21193,
	"./Toaster_Spanish_Tostadora.png": 34904,
	"./Tomato_French_Tomate.png": 50479,
	"./Tomato_German_Tomate.png": 4125,
	"./Tomato_Italian_Pomodoro.png": 93536,
	"./Tomato_Polish_Pomidor.png": 85396,
	"./Tomato_Portuguese_Tomate.png": 34538,
	"./Tomato_Spanish_Tomate.png": 1609,
	"./Tree_French_Arbre.png": 19443,
	"./Tree_German_Baum.png": 33234,
	"./Tree_Italian_Albero.png": 43718,
	"./Tree_Polish_Drzewo.png": 75583,
	"./Tree_Portuguese_Árvore.png": 78947,
	"./Tree_Spanish_Árbol.png": 18791,
	"./Triangle_French_Triangle.png": 31877,
	"./Triangle_German_Dreieck.png": 71896,
	"./Triangle_Italian_Triangolo.png": 60624,
	"./Triangle_Polish_Trójkąt.png": 90057,
	"./Triangle_Portuguese_Triângulo.png": 17734,
	"./Triangle_Spanish_Triángulo.png": 97666,
	"./Truck_French_Camion.png": 42985,
	"./Truck_German_Lastwagen.png": 50498,
	"./Truck_Italian_Camion.png": 32665,
	"./Truck_Polish_Ciężarówka.png": 15509,
	"./Truck_Portuguese_Caminhão.png": 60423,
	"./Truck_Spanish_Camión.png": 24469,
	"./Two_French_Deux.png": 41865,
	"./Two_German_Zwei.png": 98298,
	"./Two_Italian_Due.png": 90023,
	"./Two_Polish_Dwa.png": 73268,
	"./Two_Portuguese_Dois.png": 80421,
	"./Two_Spanish_Dos.png": 39827,
	"./Wall_German_Wand.png": 6025,
	"./Wallet_French_Portefeuille.png": 65289,
	"./Wallet_German_Geldbörse.png": 33904,
	"./Wallet_Italian_Portafoglio.png": 54374,
	"./Wallet_Polish_Portfel.png": 72493,
	"./Wallet_Portuguese_Carteira.png": 26740,
	"./Wallet_Spanish_Billetera.png": 98462,
	"./Want_French_Vouloir.png": 5555,
	"./Want_German_Wollen.png": 45702,
	"./Want_Italian_Volere.png": 96589,
	"./Want_Polish_Chcieć.png": 90735,
	"./Want_Portuguese_Querer.png": 43640,
	"./Want_Spanish_Desear.png": 51989,
	"./Water_French_Eau.png": 56453,
	"./Water_German_Wasser.png": 8925,
	"./Water_Italian_Acqua.png": 82361,
	"./Water_Polish_Woda.png": 51770,
	"./Water_Portuguese_Água.png": 3279,
	"./Water_Spanish_Agua.png": 93982,
	"./Watermelon_French_Pastèque.png": 79584,
	"./Watermelon_German_Wassermelone.png": 9756,
	"./Watermelon_Italian_Anguria.png": 45142,
	"./Watermelon_Polish_Arbuz.png": 62460,
	"./Watermelon_Portuguese_Melancia.png": 22682,
	"./Watermelon_Spanish_Sandía.png": 43229,
	"./Wheel_French_Roue.png": 65839,
	"./Wheel_German_Rad.png": 22157,
	"./Wheel_Italian_Ruota.png": 21769,
	"./Wheel_Polish_Koło.png": 4106,
	"./Wheel_Portuguese_Roda.png": 53721,
	"./Wheel_Spanish_Rueda.png": 50939,
	"./White_French_Blanc.png": 86950,
	"./White_German_Weiß.png": 45072,
	"./White_Italian_Bianco.png": 14514,
	"./White_Polish_Biały.png": 52948,
	"./White_Portuguese_Branco.png": 3132,
	"./White_Spanish_Blanco.png": 35355,
	"./Window_French_Fenêtre.png": 33767,
	"./Window_German_Fenster.png": 30216,
	"./Window_Italian_Finestra.png": 37341,
	"./Window_Polish_Okno.png": 64615,
	"./Window_Portuguese_Janela.png": 19325,
	"./Window_Spanish_Ventana.png": 33006,
	"./Yellow_French_Jaune.png": 67718,
	"./Yellow_German_Gelb.png": 85089,
	"./Yellow_Italian_Giallo.png": 70063,
	"./Yellow_Polish_Żółty.png": 31491,
	"./Yellow_Portuguese_Amarelo.png": 46293,
	"./Yellow_Spanish_Amarillo.png": 92928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88033;